import { RulAi } from 'rulAi'

import App from 'components/app/App'

export function AppDispatcher(): JSX.Element {
  RulAi.loadForV2()
  return <App />
}
